__turbopack_context__.v({
  "active": "LabeledSelect-module-scss-module__R3ZN0W__active",
  "disabled": "LabeledSelect-module-scss-module__R3ZN0W__disabled",
  "error": "LabeledSelect-module-scss-module__R3ZN0W__error",
  "error-text": "LabeledSelect-module-scss-module__R3ZN0W__error-text",
  "loading": "LabeledSelect-module-scss-module__R3ZN0W__loading",
  "long": "LabeledSelect-module-scss-module__R3ZN0W__long",
  "select-arrow": "LabeledSelect-module-scss-module__R3ZN0W__select-arrow",
  "select-preloader": "LabeledSelect-module-scss-module__R3ZN0W__select-preloader",
  "select__container": "LabeledSelect-module-scss-module__R3ZN0W__select__container",
  "select__droplist": "LabeledSelect-module-scss-module__R3ZN0W__select__droplist",
  "select__plate": "LabeledSelect-module-scss-module__R3ZN0W__select__plate",
  "short": "LabeledSelect-module-scss-module__R3ZN0W__short",
  "spin": "LabeledSelect-module-scss-module__R3ZN0W__spin",
});
